/* eslint-disable max-len */
/**
 * French translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {},
  LABEL: {
    NO_ROWS_MENTIONS: 'Aucune mention'
  },
  SENTENCE: {
    INSTAGRAM_LINK:
      'Vous avez mentionné Prozis sur une histoire Instagram le {publishedAt}',
    NO_ROWS_MENTIONS: 'Tu n\'as pas encore mentionné Prozis sur ton Instagram'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
